import * as React from 'react';
import { Menu } from '@beehive/components';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail';

interface MenuType {
  key: string;
  name: string;
}
export const MENU_KEYS: MenuType[] = [
  { key: 'detail', name: 'menuKeys.detail' },
  { key: 'progress', name: 'menuKeys.progress' },
];

export interface TabsProps {
  prefixCls: string;
  handleChangeMenu: Function;
  selectedMenu: string;
}

class Tabs extends React.Component<TabsProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
    menuKey: PropTypes.string,
    detail: PropTypes.object,
  };

  constructor(props: TabsProps) {
    super(props);
    this.state = {
      selectedMenu: MENU_KEYS[0].key,
    };
  }

  private notShowProgress = () => {
    const { menuKey } = this.context;
    return ['myAdvance'].includes(menuKey);
  }

  public render() {
    const { intl, detail } = this.context;
    const { prefixCls, selectedMenu, handleChangeMenu } = this.props;
    const className = `${prefixCls}-tabs`;

    if (!detail) {
      return null;
    }

    let menus = [...MENU_KEYS];
    if (this.notShowProgress()) {
      menus = menus.filter((item: any) => item.key !== 'progress');
    }

    return (
      <div className={className}>
        <Menu mode="horizontal" selectedKeys={[selectedMenu]} levelStyle="secondary" onSelect={handleChangeMenu}>
          {menus.map((menu: MenuType) => {
            return <Menu.Item key={menu.key}>
              {intl.formatMessage(messages[menu.name])}
            </Menu.Item>;
          })}
        </Menu>
      </div>
    );
  }

}

export default Tabs;
